"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Deferred {
    constructor() {
        this._state = "none";
        let escapedResolve;
        let escapedReject;
        this.promise = new Promise((resolve, reject) => {
            escapedResolve = resolve;
            escapedReject = reject;
        });
        this.resolve = val => {
            this._state = "resolved";
            escapedResolve(val);
        };
        this.reject = reason => {
            this._state = "rejected";
            escapedReject(reason);
        };
    }
    get state() {
        return this._state;
    }
}
exports.Deferred = Deferred;
class Barrier {
    constructor() {
        this.deferred = new Deferred();
        this.unlock = this.deferred.resolve;
        this.reject = this.deferred.reject;
        this.onUnlocked = this.deferred.promise;
    }
    get state() {
        return this.deferred.state;
    }
}
exports.Barrier = Barrier;
class ProducerConsumer {
    constructor() {
        this.barriers = [];
        this.nextBarriers = [];
    }
    popOrNext() {
        let b = this.barriers.shift();
        if (!b) {
            b = new Deferred();
            this.nextBarriers.push(b);
        }
        return b;
    }
    produce(value) {
        this.popOrNext().resolve(value);
    }
    rejectSingle(reason) {
        this.popOrNext().reject(reason);
    }
    consume() {
        let b = this.nextBarriers.shift();
        if (!b) {
            b = new Deferred();
            this.barriers.push(b);
        }
        return b.promise;
    }
}
exports.ProducerConsumer = ProducerConsumer;
//# sourceMappingURL=synchronization.js.map